// public/js/features/announcements/render.js
// Render a post's typed blocks to safe HTML (all text is escaped — no raw HTML
// is ever injected). Block types: heading | paragraph | list | image.
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export function renderBlocks(blocks) {
  if (!Array.isArray(blocks) || !blocks.length) return '<p class="text-muted fst-italic">No content.</p>';
  return blocks.map(b => {
    if (!b || typeof b !== 'object') return '';
    switch (b.type) {
      case 'heading':
        return `<h5 class="mt-3 mb-2 fw-semibold">${esc(b.text)}</h5>`;
      case 'paragraph':
        return `<p class="mb-2">${esc(b.text)}</p>`;
      case 'list':
        return `<ul class="mb-2 ps-4">${(b.items || []).map(i => `<li>${esc(i)}</li>`).join('')}</ul>`;
      case 'image':
        return `<figure class="my-3 text-center">
                  <img src="${esc(b.url)}" alt="${esc(b.caption || '')}" loading="lazy"
                       style="max-width:100%;height:auto;border:1px solid var(--bs-border-color,#dee2e6);border-radius:8px;">
                  ${b.caption ? `<figcaption class="small text-muted mt-1">${esc(b.caption)}</figcaption>` : ''}
                </figure>`;
      default:
        return '';
    }
  }).join('');
}

export function announcementDate(post) {
  const iso = post.publishedAt || post.createdAt;
  try { return new Date(iso).toLocaleDateString(navigator.language, { year: 'numeric', month: 'long', day: 'numeric' }); }
  catch { return iso || ''; }
}
